export default __webpack_public_path__ + "static/media/Umar_FM.c6ef7ee6.png";